/** @format */

import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { CompareProductDetailsError, CompareProductItem } from '@compare/data-access';
import {
	HeaderStoreSelection,
	ProductAvailabilityCollection
} from '@shared/data-access/interfaces';

import { ProductAvailabilityComponent } from '@shared/components';
import { SkeletonFulfillmentSectionComponent } from '../skeleton-fulfillment-section/skeleton-fulfillment-section.component';
import { Store } from '@ngrx/store';
import { selectUserStoreInfo, selectUserZipCode } from '@state/data-access';

@Component({
	selector: 'compare-components-fulfillment-section',
	imports: [SkeletonFulfillmentSectionComponent, ProductAvailabilityComponent],
	templateUrl: './fulfillment-section.component.html',
	styleUrl: './fulfillment-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FulfillmentSectionComponent {
	private readonly store = inject(Store);

	readonly productEcode = input.required<string>();
	readonly productDetailsData = input.required<CompareProductItem | null>();
	readonly compareProductsAvailability = input.required<ProductAvailabilityCollection>();

	readonly userStoreInfo = this.store.selectSignal<HeaderStoreSelection>(selectUserStoreInfo);
	readonly userZipCode = this.store.selectSignal<string>(selectUserZipCode);

	readonly isLoadingFulfillment = computed(() => !this.compareProductsAvailability());
	readonly isLoading = computed(() => !this.productDetailsData());

	readonly productErrors: Signal<CompareProductDetailsError[]> = computed(() =>
		this.checkForProductErrors(this.productDetailsData())
	);

	private checkForProductErrors(
		productDetailsData: CompareProductItem | null
	): CompareProductDetailsError[] {
		if (!productDetailsData) {
			return [];
		}

		const errors = [];

		if (!productDetailsData.style) {
			errors.push('noStyle');
		}

		if (!productDetailsData.style?.prices) {
			errors.push('noPrices');
		}

		return errors;
	}
}
